import { useTranslation } from 'next-i18next';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { Chip, type ChipProps } from '@/ui_v3';
import { cn } from '@/utils';
import { type BuildQuizListItem } from '@/views/build/form/schema/BuildQuizListSchema';
import { focusField } from '../../focus/focusUtils';
import { useEditMode } from '../../focus/useIsEditMode';
import { useQuizControl } from '../QuizControlProvider';
import { QuizImage } from '../QuizImage';
import { WithUnderline } from '../WithUnderline';
export const HintContent = ({
  isVisible,
  hint
}: {
  isVisible: boolean;
  hint: BuildQuizListItem['hint'];
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    onEditModeChange
  } = useEditMode();
  const {
    index
  } = useQuizControl();
  if (!hint) {
    return null;
  }
  const {
    type,
    value
  } = hint;
  return <div className={cn('hidden', isVisible && 'block')} data-sentry-component="HintContent" data-sentry-source-file="HintContent.tsx">
      <div className="group relative flex cursor-pointer items-center gap-xs" onMouseDown={e => {
      e.preventDefault();
    }} onClick={e => {
      e.stopPropagation();
      onEditModeChange(true);
      focusField(`quizList.${index}.hint`, {
        scroll: true,
        delay: 200
      });
    }}>
        <HintIndicatorChip className="shrink-0" data-sentry-element="HintIndicatorChip" data-sentry-source-file="HintContent.tsx" />
        <WithUnderline className="grow pt-xs" data-sentry-element="WithUnderline" data-sentry-source-file="HintContent.tsx">
          {type === 'text' && <span className={cn('break-all text-body-lg-medium text-alternative block', !value && 'text-disabled')}>
              {value || t('quizCreateItem.text.description')}
            </span>}
          {type === 'image' && (value ? <QuizImage.Container className="size-[62px]" onClick={() => {
          imageDetailModal.open(value);
        }}>
                <QuizImage.Thumbnail src={value} alt="hint" />
              </QuizImage.Container> : <span className={cn('break-words text-body-lg-medium text-alternative', !value && 'text-disabled')}>
                {t('quizCreateItem.text.description')}
              </span>)}
          {type === 'youtube' && (value ? <a href={value} target="_blank" rel="noopener noreferrer" className="break-all text-body-lg-medium text-link">
                {value}
              </a> : <span className={cn('break-words text-body-lg-medium text-alternative overflow-hidden', !value && 'text-disabled')}>
                {t('quizCreateItem.text.description')}
              </span>)}
        </WithUnderline>
      </div>
    </div>;
};
const HintIndicatorChip = (props: Omit<ChipProps, 'children'>) => {
  const {
    className,
    ...rest
  } = props;
  const {
    t
  } = useTranslation(['common']);
  return <Chip {...rest} size="sm" className={cn('rounded-xl border border-alternative px-xs py-3xs text-body-sm-semibold', className)} data-sentry-element="Chip" data-sentry-component="HintIndicatorChip" data-sentry-source-file="HintContent.tsx">
      {t('common:quizItem.hint.title')}
    </Chip>;
};